import ExtensiveClass from '../../../assets/img/home/extensive-classroom.png';

export default function CourseSection() {
  return (
    <>
      <section
        className="padding-tb-120px padding-bottom-200px sm-ptb-30px bg-middle-pink baby-middle-wave"
        id="courese"
      >
        <div className="container">
          <div className="">
            <div className="row">
              <div
                className="col-md-6 wow fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <img width="100%" className="" src={ExtensiveClass} alt="Eminence" />
              </div>
              <div
                className="col-md-6 wow fadeInRight"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <div className="firo-title dark text-left margin-top-180px margin-left-30px margin-left-sm-0px sm-mb-20px sm-mt-30px">
                  <h2 className="title">Innovative Technology</h2>
                  <div className="description line-height-30">
                    We offer 2-Year, 3-year and 4-year classroom program course.
                  </div>
                  <a href="contact.php" className="firo-bottom sm mt-20">
                    Find out more
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
